<template>
  <transition
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      appear
      @after-enter="isShowContent = true"
  >
    <div class="popupBackground" @click="handleClickClose">
      <transition
          enter-active-class="flipHorizontalTop"
          leave-active-class="flipHorizontalBottom"
          @after-leave="$emit('close')"
      >
        <div
            v-if="isShowContent"
            class="popupFarm"
            :class="cssClassModifier('popupFarm', classModifier)"
            @click.stop
        >
<!--          <gl-notification-->
<!--              v-if="notification.type"-->
<!--              :notification="notification"-->
<!--              class="popupFarm__notification"-->
<!--              @close="handleClickCloseNotification"-->
<!--          />-->
          <div class="popupFarm__closeContainer">
            <button class="popupFarm__close" @click="handleClickClose">
              <svg width="24" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 5.91L17.59 4.5 12 10.09 6.41 4.5 5 5.91l5.59 5.59L5 17.09l1.41 1.41L12 12.91l5.59 5.59L19 17.09l-5.59-5.59L19 5.91z"/></svg>
            </button>
          </div>
          <div class="popupFarm__body">
            <slot :close-popup="handleClickClose" />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
// import GlNotification from '@gl/GlNotification'

import { cssClassModifier } from '@/mixins'

export default {
  name: 'GlPopup',
  components: {
    // GlNotification,
  },
  mixins: [cssClassModifier],
  props: {
    classModifier: {
      type: [Array, String],
      required: false,
      default: '',
    },
    // notification: {
    //   type: Object,
    //   default: () => ({}),
    // },
  },
  data() {
    return {
      isShowContent: false,
      notificationTimer: null,
    }
  },
  // watch: {
  //   notification() {
  //     clearTimeout(this.notificationTimer)
  //     this.notificationTimer = setTimeout(
  //         this.handleClickCloseNotification,
  //         3000
  //     )
  //   },
  // },
  methods: {
    handleClickClose() {
      this.isShowContent = false
    },
    // handleClickCloseNotification() {
    //   clearTimeout(this.notificationTimer)
    //   this.$emit('close-notification')
    // },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/popup';
</style>
